import { LoadingLayout } from 'components';
import { useScrollToTop } from 'hooks';
import { ErrorFallback } from 'modules/App/ErrorFallback';

import { getClientMainInfo } from '../helpers/getClientMainInfo';
import { useClient, useClientStatus } from '../hooks';
import { ClientView } from '../views/ClientView';

export const ClientContainer = () => {
  const {
    client,
    loading,
    countries,
    countriesLoading,
    error,
    hasRepresentative,
    initialValues,
    submitLoading,
    formError,
    managers,
    managersLoading,
    breadcrumbsTitles,
    revokeOtpVerificationLoading,
    deleteLoading,
    isEditablePersonalAccountNumber,
    unlockClient,
    lockClientIfPossible,
    onSubmit,
    onShowVersionHistory,
    onRevokeOtpVerification,
    onSendInvitationToAccount,
    onLinkToBright,
    onClickRepresentative,
    onDownloadClientQuestionnaire,
    onDelete,
  } = useClient();

  const {
    loading: loadingStatuses,
    statuses: statusesForChange,
    submitLoading: submitLoadingStatus,
    visibleOnboardingStatuses,
    fetchAvailableStatuses: fetchStatusesForChange,
    onChangeOnboardingStatus,
    onChangeAccountStatus,
  } = useClientStatus(client);

  useScrollToTop([]);

  if (error || (!client && !loading)) {
    return <ErrorFallback />;
  }

  if (loading || !client || !initialValues) {
    return <LoadingLayout />;
  }

  const mainInfo = getClientMainInfo(client);

  return (
    <ClientView
      breadcrumbsTitles={breadcrumbsTitles}
      countries={countries}
      countriesLoading={countriesLoading}
      currentAccountStatus={client.accountStatus}
      currentOnboardingStatus={client.onboardingStatus}
      deleteLoading={deleteLoading}
      fetchStatusesForChange={fetchStatusesForChange}
      hasRepresentative={hasRepresentative}
      initialErrors={formError}
      initialValues={initialValues}
      isEditablePersonalAccountNumber={isEditablePersonalAccountNumber}
      kycData={client.kyc}
      loadingStatuses={loadingStatuses}
      lockClientIfPossible={lockClientIfPossible}
      mainInfo={mainInfo}
      managers={managers}
      managersLoading={managersLoading}
      onboardingData={client.onboarding}
      representativeInfo={client.representative}
      revokeOtpVerificationLoading={revokeOtpVerificationLoading}
      statusesForChange={statusesForChange}
      submitLoading={submitLoading}
      submitLoadingStatus={submitLoadingStatus}
      unlockClient={unlockClient}
      visibleOnboardingStatuses={visibleOnboardingStatuses}
      onChangeAccountStatus={onChangeAccountStatus}
      onChangeOnboardingStatus={onChangeOnboardingStatus}
      onClickRepresentative={onClickRepresentative}
      onDelete={onDelete}
      onDownloadClientQuestionnaire={onDownloadClientQuestionnaire}
      onLinkToBright={onLinkToBright}
      onRevokeOtpVerification={onRevokeOtpVerification}
      onSendInvitationToAccount={onSendInvitationToAccount}
      onShowVersionHistory={onShowVersionHistory}
      onSubmit={onSubmit}
    />
  );
};
